export default __webpack_public_path__ + "static/media/offers-2.c5f3e958.jpg";